module.exports = __webpack_public_path__ + "img/mastercard.f6bc3bab.svg";